<template>
  <with-actions>
    <div class="row">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'order_channel_type' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <div class="card mb-5">
          <div class="card-body">
            <div>
              <div
                class="form-group"
                v-if="!order_channel_type.id || order_channel_type.component_name == 'ExternalComponent'"
              >
                <label>Fetch config from nShift order channel adapter</label>
                <div class="row">
                  <div class="col" v-if="external_configurables.length > 0">
                    <select class="form-control" @change="(e) => fill(external_configurables[e.target.value])">
                      <option :value="null">--</option>
                      <option :value="i" v-for="(c, i) in external_configurables">{{ c.name }}</option>
                    </select>
                  </div>
                  <div class="col-auto">
                    <div class="btn btn-outline-primary" @click="loadExternalConfig">Load config</div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>{{ 'name' | t }}</label>
                <input class="form-control" v-model="order_channel_type.name" />
              </div>
              <div class="form-group">
                <label>{{ 'component_name' | t }}</label>
                <input
                  class="form-control"
                  :class="order_channel_type.component_name ? '' : 'border-danger'"
                  v-model="order_channel_type.component_name"
                />
                <div class="text-danger" v-if="!order_channel_type.component_name">{{ 'cannot_be_empty' | t }}!</div>
                <div
                  class="text-danger"
                  v-if="order_channel_type.id && order_channel_type.component_name != original_component_name"
                >
                  {{ 'value_has_changed' | t(this.original_component_name) }}
                </div>
                <small class="text-danger">{{ 'component_name_disclaimer' | t }}</small>
              </div>
              <div class="form-group">
                <label>{{ 'fulfillment_job_name' | t }}</label>
                <input class="form-control" v-model="order_channel_type.fulfillment_job_name" /><small
                  class="text-danger"
                  >{{ 'fulfillment_job_name_disclaimer' | t }}</small
                >
              </div>
              <div class="form-group">
                <label>{{ 'support_url' | t }}</label>
                <input class="form-control" v-model="order_channel_type.support_url" />
              </div>
              <div class="form-group">
                <label>{{ 'onboarding_url' | t }}</label>
                <input class="form-control" v-model="order_channel_type.onboarding_url" />
              </div>
              <div class="form-group">
                <label>{{ 'module_link' | t }}</label>
                <input class="form-control" v-model="order_channel_type.module_link" />
              </div>
              <div class="form-group">
                <p>
                  <label>{{ 'list_logo' | t }}</label>
                </p>
                <p><img :src="order_channel_type.list_logo" width="200" v-if="order_channel_type.list_logo" /></p>
                <input type="file" v-on:change="listLogoChange" />
              </div>
              <div class="form-group">
                <checkbox label="Can autofulfill" v-model="order_channel_type.can_autofulfill"></checkbox>
              </div>
              <div class="form-group">
                <checkbox label="Can limit drop points" v-model="order_channel_type.can_limit_drop_points"></checkbox>
              </div>
              <div class="form-group">
                <checkbox
                  :label="$t('supports_rate_quoting')"
                  v-model="order_channel_type.supports_rate_quoting"
                ></checkbox>
              </div>
              <div class="form-group">
                <checkbox
                  :label="$t('uses_scheduled_import')"
                  v-model="order_channel_type.uses_scheduled_import"
                ></checkbox>
              </div>
              <div class="form-group">
                <checkbox :label="$t('supports_id_import')" v-model="order_channel_type.supports_id_import"></checkbox>
              </div>
              <div class="form-group">
                <checkbox
                  :label="$t('supports_statuses_import')"
                  v-model="order_channel_type.supports_statuses_import"
                ></checkbox>
              </div>
              <div class="form-group">
                <checkbox
                  :label="$t('supports_time_interval_import')"
                  v-model="order_channel_type.supports_time_interval_import"
                ></checkbox>
              </div>
              <div class="form-group">
                <checkbox
                  :label="$t('supports_vat_in_checkout')"
                  v-model="order_channel_type.supports_vat_in_checkout"
                ></checkbox>
              </div>
              <div class="form-group">
                <checkbox
                  :label="$t('create_configuration_token')"
                  v-model="order_channel_type.create_configuration_token"
                ></checkbox>
              </div>
              <div class="form-group">
                <checkbox :label="$t('hide')" v-model="order_channel_type.hide"></checkbox>
              </div>
              <div class="form-group">
                <label>{{ 'description' | t }}</label>
                <textarea class="form-control" v-model="order_channel_type.description" rows="8"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'local_attrs' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <local-attrs v-model="order_channel_type.local_attrs"></local-attrs>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'global_attrs' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <global-attrs v-model="order_channel_type.global_attrs"></global-attrs>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 text-right"></div>
      <div class="col-md-8">
        <button class="btn btn-success btn-lg" @click="save($event)" :disabled="!valid">
          {{ (order_channel_type.id ? 'update_order_channel_type ' : 'create_order_channel_type') | t }}
        </button>
      </div>
    </div>
  </with-actions>
</template><script>
import _ from 'lodash';
import Vue from 'vue';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts.js';
import moment from 'moment-es6';
import $ from 'jquery';

export default {
  data: function () {
    return {
      errors: [],
      order_channel_type: this.value,
      original_component_name: this.value.component_name,
      external_order_channel_type_name: '',
      external_configurables: []
    };
  },
  props: { value: Object },
  methods: {
    async loadExternalConfig() {
      const { data } = await Api.findAll('external_order_channel_type_configs');

      this.external_configurables = data.types;
    },
    fill(config) {
      console.log('fill', config);

      this.order_channel_type.name = config.name;
      this.order_channel_type.component_name = 'ExternalComponent';
      this.order_channel_type.fulfillment_job_name = 'Jobs::CloseExternalJob';

      // Keep old local attrs
      for (let o of config.custom_attributes_options) {
        if (!this.order_channel_type.local_attrs.find((a) => a.attr_key == o.attribute_key)) {
          this.order_channel_type.local_attrs.push({
            attr_key: o.attribute_key,
            attr_name: o.attribute_name,
            attr_type: o.attribute_type,
            local_attr_enums: o.enum
              ? o.enum.map((e) => ({
                  enum_name: e.enum_name,
                  enum_value: e.enum_key
                }))
              : []
          });
        }
      }

      // Add global_attr external_order_channel_code
      this.order_channel_type.global_attrs.push({
        attr_key: 'external_order_channel_code',
        attr_value: config.shop_type
      });
    },
    save: function (event) {
      $(event.target).loading();

      if (this.order_channel_type && this.order_channel_type.id) {
        Api.update('order_channel_types', this.order_channel_type)
          .then(({ data, errors, meta, links }) => {
            this.$router.push({ name: 'order_channel_types' });
            $(event.target).loading(false);
          })
          .catch(({ errors }) => {
            Alerts.danger(errors[0].title, errors[0].detail);
            $(event.target).loading(false);
          });
      } else {
        Api.create('order_channel_types', this.order_channel_type)
          .then(({ data, errors, meta, links }) => {
            this.$router.push({ name: 'order_channel_types' });
            $(event.target).loading(false);
          })
          .catch(({ errors }) => {
            Alerts.danger(errors[0].title, errors[0].detail);
            $(event.target).loading(false);
          });
      }
    },

    listLogoChange: function (e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createListLogo(files[0]);
    },
    createListLogo: function (file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.order_channel_type.list_logo = e.target.result;
      };
      reader.readAsDataURL(file);
      //  this.$emit('input', this.carrier_type.list_logo);
    },
    valid: function () {
      return true;
    }
  },
  asyncComputed: {},
  mounted: function () {
    this.setBreadcrumbs([
      { to: { name: 'order_channel_types' }, text: 'Order channel types' },
      {
        to: { name: 'order_channel_type_create' },
        text: 'New order channel type'
      }
    ]);
  }
};
</script>
